import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Skeleton } from '@mui/material';
import { ShowroomTestIds } from '../../utils/testIds/Showroom.testIds';
import LoadingCards, { LoadingCardsProps } from './LoadingCards';
import Section, { SectionProps } from './Section';

export type EmphasisMediasSectionLoadingProps = {
  sectionProps?: SectionProps;
  loadingCardsProps?: LoadingCardsProps;
};

const EmphasisMediasSectionLoading = ({
  sectionProps,
  loadingCardsProps,
}: EmphasisMediasSectionLoadingProps) => (
  <Section {...sectionProps} readOnly>
    <Box
      sx={{
        pb: { xs: 3, sm: 2 },
      }}
    >
      <Typography variant="h5" color="text.primary" testId={ShowroomTestIds.FEATURED_MEDIA_DETAILS}>
        <Skeleton variant="text" width="30vw" />
      </Typography>
    </Box>
    <LoadingCards {...loadingCardsProps} />
  </Section>
);

export default EmphasisMediasSectionLoading;
